import { render, staticRenderFns } from "./ManageTradeShowsPage.vue?vue&type=template&id=1ad2e77a&scoped=true&"
import script from "./ManageTradeShowsPage.vue?vue&type=script&lang=js&"
export * from "./ManageTradeShowsPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageTradeShowsPage.vue?vue&type=style&index=0&id=1ad2e77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad2e77a",
  null
  
)

export default component.exports